import AssignmentList from "./AssignmentList";

export default AssignmentList;
